module.exports = __webpack_public_path__ + "img/service-8-3.5d694a0d.jpeg";